import getContentsByLocale from './getContentsByLocale'
import getPackConfigByLocale from './getPackConfigByLocale'
import getLodgingTypesByLocale from './getLodgingTypesByLocale'
import { LocaleContents } from '../contents/contents'
import { LocalePackConfig } from '../config/pack-config'
import { LocaleLodgingTypeConfig } from '../config/lodging-type-config'

export type ConfigForLocale = {
    contents: LocaleContents
    packageValues: LocalePackConfig
    lodgingTypes: LocaleLodgingTypeConfig
}

function getConfigForLocale(locale: string): ConfigForLocale {
    if (!locale) throw new Error('locale is mandatory in getConfigForLocale')

    // If the locale is cse, use the configs for fr_FR
    const formattedLocale: string = locale === 'fr_FR_CSE' ? 'fr_FR' : locale.replaceAll('-', '_')

    const contents: LocaleContents = getContentsByLocale(formattedLocale)
    const packageValues: LocalePackConfig = getPackConfigByLocale(formattedLocale)
    const lodgingTypes: LocaleLodgingTypeConfig = getLodgingTypesByLocale(formattedLocale)

    return {
        contents,
        packageValues,
        lodgingTypes
    }
}

export default getConfigForLocale
